/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowAdmissionReasoning
 */
export interface ShadowAdmissionReasoning {
    /**
     * 
     * @type {string}
     * @memberof ShadowAdmissionReasoning
     */
    summary: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionReasoning
     */
    admit_factors: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionReasoning
     */
    reject_factors: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionReasoning
     */
    uncertainty_factors: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShadowAdmissionReasoning
     */
    confidence_explanation: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionReasoning
     */
    follow_up_items?: Array<string>;
}

/**
 * Check if a given object implements the ShadowAdmissionReasoning interface.
 */
export function instanceOfShadowAdmissionReasoning(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "summary" in value;
    isInstance = isInstance && "admit_factors" in value;
    isInstance = isInstance && "reject_factors" in value;
    isInstance = isInstance && "uncertainty_factors" in value;
    isInstance = isInstance && "confidence_explanation" in value;

    return isInstance;
}

export function ShadowAdmissionReasoningFromJSON(json: any): ShadowAdmissionReasoning {
    return ShadowAdmissionReasoningFromJSONTyped(json, false);
}

export function ShadowAdmissionReasoningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowAdmissionReasoning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summary': json['summary'],
        'admit_factors': json['admit_factors'],
        'reject_factors': json['reject_factors'],
        'uncertainty_factors': json['uncertainty_factors'],
        'confidence_explanation': json['confidence_explanation'],
        'follow_up_items': !exists(json, 'follow_up_items') ? undefined : json['follow_up_items'],
    };
}

export function ShadowAdmissionReasoningToJSON(value?: ShadowAdmissionReasoning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summary': value.summary,
        'admit_factors': value.admit_factors,
        'reject_factors': value.reject_factors,
        'uncertainty_factors': value.uncertainty_factors,
        'confidence_explanation': value.confidence_explanation,
        'follow_up_items': value.follow_up_items,
    };
}

